import { map } from 'rxjs/operators';
import { ValidationError } from '../queries/generated';

interface Errorable {
  errors?: ValidationError[];
}

export function finalMap<T extends Errorable, K extends keyof T>(key: K) {
  return map<T, T[K]>((resp) => {
    if (resp.errors?.length) {
      throw resp.errors;
    }
    return resp[key];
  });
}

export function castAs<T>() {
  return map((value) => <T>(<unknown>value));
}
